import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ColorPaleta, PALETA_COLORES } from '@core/constants/paleta-colores.constants';

@Component({
  selector: 'app-selector-color',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './selector-color.component.html',
  styleUrl: './selector-color.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectorColorComponent {
  @Input() public colorActual = '';
  @Input() public coloresOcupados = new Map<string, string>();
  @Input() public paleta: ColorPaleta[] = PALETA_COLORES;
  @Input() public rolNombre = '';

  @Output() public colorSeleccionado = new EventEmitter<string>();
  @Output() public confirmarSeleccion = new EventEmitter<string>();
  @Output() public cancelar = new EventEmitter<void>();

  public colorTemporal = signal<string | null>(null);

  public seleccionarColor(codigo: string): void {
    this.colorTemporal.set(codigo);
    this.colorSeleccionado.emit(codigo);
  }

  public confirmar(): void {
    const color = this.colorTemporal();
    if (color) {
      this.confirmarSeleccion.emit(color);
    }
  }

  public cancelarSeleccion(): void {
    this.colorTemporal.set(null);
    this.cancelar.emit();
  }

  public estaOcupado(codigo: string): boolean {
    return this.coloresOcupados.has(codigo) && this.coloresOcupados.get(codigo) !== this.getRolActual();
  }

  public getRolOcupado(codigo: string): string {
    return this.coloresOcupados.get(codigo) ?? '';
  }

  public estaSeleccionado(codigo: string): boolean {
    const temporal = this.colorTemporal();
    return temporal === codigo || (!temporal && this.colorActual === codigo);
  }

  private getRolActual(): string {
    return this.coloresOcupados.get(this.colorActual) ?? '';
  }
}
